import React, { useEffect, useState } from "react";
import CustomTabs from "../../pages/shared/custom-tabs";
import { JMC_COLORS } from "../../styles/colors";
import * as Icons from "@mui/icons-material";
import { Box } from "@mui/material";
import TopNavBar from "../../components/TopNavBar";
import ProductionOrders from "./prodution-order";
import ProductionDispatch from "./production-dispatch";
import ProductionWeeklyReport from "./production-weekly-report";
import LoadingWithText from "../../components/Loader";

function Production() {

    const allTabs = [
        {
            label: "Production Orders",
            icon: <Icons.ProductionQuantityLimits sx={{ color: JMC_COLORS.chemicals }} />,
            color: JMC_COLORS.chemicals,
            area: "production",
        },
        {
            label: "Dispatch Planning",
            icon: <Icons.SendTimeExtension sx={{ color: JMC_COLORS.gas }} />,
            color: JMC_COLORS.gas,
            area: "dispatch",
        },
        {
            label: "Weekly View",
            icon: <Icons.Assessment sx={{ color: JMC_COLORS.power }} />,
            color: JMC_COLORS.power,
            area: "weekly",
        },
    ];

    const [selectedTab, setSelectedTab] = useState(0);
    const [showLoader, setShowLoader] = useState(false);

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

    // Show loader only when arriving on the Production page
    useEffect(() => {
        setShowLoader(true);
        const t = setTimeout(() => setShowLoader(false), 1200);
        return () => clearTimeout(t);
    }, []);

    return (
        <Box sx={{
            backgroundColor: JMC_COLORS.background,
            minHeight: "100vh"
        }}>
            <TopNavBar />
            {/* {showLoader && <LoadingWithText />} */}
            <Box sx={{
                px: { xs: 3, sm: 7 },
            }}>


                <Box >
                    <h2 >Production Planning </h2>
                    <CustomTabs

                        tabValue={selectedTab}
                        handleTabChange={handleTabChange}
                        tabs={allTabs}
                    />
                </Box>

                <Box sx={{mt:2 }}>
                    {selectedTab === 0 && <ProductionOrders />}
                    {selectedTab === 1 && <ProductionDispatch />}
                    {selectedTab === 2 && <ProductionWeeklyReport />}
                </Box>
            </Box>

        </Box>
    );
}

export default Production;
